import React from 'react';
import { selectComponent, selectedComponent as getSelectedComponent } from '../../../redux/selectedComponentSlice';
import { selectedPage } from '../../../redux/selectedPageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Select, Flex, FormLabel } from '@chakra-ui/react';
import { updateComponent } from '../../../redux/pagesSlice';
import { cssVariables } from '../../../redux/cssVariablesSlice';

export const types = {
	color: [
		{ value: '--brand-color-primary-pure', name: 'Brand Color Primary' },
		{ value: '--brand-color-primary-light', name: 'Brand Color Light' },
		{ value: '--brand-color-primary-medium', name: 'Brand Color Medium' },
		{ value: '--brand-color-primary-dark', name: 'Brand Color Dark' },
		{ value: '--brand-color-secondary-pure', name: 'Brand Color Secondary' },
		{ value: '--brand-color-secondary-light', name: 'Brand Color Secondary Light' },
		{ value: '--brand-color-secondary-medium', name: 'Brand Color Secondary Medium' },
		{ value: '--brand-color-secondary-dark', name: 'Brand Color Secondary Dark' },
		{ value: '--text-color-1', name: 'Text Color Primary' },
		{ value: '--text-color-1-light', name: 'Text Color Primary Light' },
		{ value: '--text-color-1-medium', name: 'Text Color Primary Medium' },
		{ value: '--text-color-1-dark', name: 'Text Color Primary Dark' },
		{ value: '--cta-color-pure', name: 'CTA Color' },
		{ value: '--cta-color-hover', name: 'CTA Color Hover' },
		{ value: '--cta-color-focus', name: 'CTA Color Active' },
		{ value: '--support-color-1', name: 'Support Color 1' },
		{ value: '--support-color-2', name: 'Support Color 2' },
		{ value: '--support-color-3', name: 'Support Color 3' },
		{ value: '--support-color-4', name: 'Support Color 4' },
		{ value: '--white', name: 'White' },
		{ value: '--neutral-color-high-light', name: 'Neutral High Light' },
		{ value: '--neutral-color-high-medium', name: 'Neutral High Medium' },
		{ value: '--neutral-color-high-dark', name: 'Neutral High Dark' },
		{ value: '--black', name: 'Black' },
		{ value: '--neutral-color-low-light', name: 'Neutral Low Light' },
		{ value: '--neutral-color-low-medium', name: 'Neutral Low Medium' },
		{ value: '--neutral-color-low-dark', name: 'Neutral Low Dark' },
		{ value: '--transparent', name: 'Transparent' },
	],
	borderRadius: [
		{ value: '--border-radius-none', name: 'None' },
		{ value: '--border-radius-xs', name: 'Xs' },
		{ value: '--border-radius-sm', name: 'Sm' },
		{ value: '--border-radius-md', name: 'Md' },
		{ value: '--border-radius-lg', name: 'Lg' },
		{ value: '--border-radius-pill', name: 'Pill' },
		{ value: '--border-radius-circular', name: 'Circular' },
	],
	borderWidth: [
		{ value: '--border-width-none', name: 'None' },
		{ value: '--border-width-hairline', name: 'Hairline' },
		{ value: '--border-width-thin', name: 'Thin' },
		{ value: '--border-width-thick', name: 'Thick' },
		{ value: '--border-width-heavy', name: 'Heavy' },
	],
	fontSize: [
		{ value: '--font-size-xxxs', name: 'xxxs' },
		{ value: '--font-size-xxs', name: 'xxs' },
		{ value: '--font-size-xs', name: 'xs' },
		{ value: '--font-size-sm', name: 'sm' },
		{ value: '--font-size-md', name: 'md' },
		{ value: '--font-size-lg', name: 'lg' },
		{ value: '--font-size-xl', name: 'xl' },
		{ value: '--font-size-xxl', name: 'xxl' },
		{ value: '--font-size-xxxl', name: 'xxxl' },
		{ value: '--font-size-display', name: 'display' },
		{ value: '--font-size-giant', name: 'giant' },
		{ value: '--font-size-titan', name: 'titan' },
	],
	fontWeight: [
		{ value: '--font-weight-200', name: 'Extra Light' },
		{ value: '--font-weight-300', name: 'Light' },
		{ value: '--font-weight-400', name: 'Regular' },
		{ value: '--font-weight-500', name: 'Regular' },
		{ value: '--font-weight-600', name: 'Semi Bold' },
		{ value: '--font-weight-700', name: 'Bold' },
		{ value: '--font-weight-900', name: 'Black' },
	],
	typography: [
		{ value: '--main-font', name: 'Main Font' },
		{ value: '--main-font-2', name: 'Secondary Font' },
	],
	spacing: [
		{ value: 0, name: 'None' },
		{ value: '--spacing-atom', name: 'Atom' },
		{ value: '--spacing-nano', name: 'Nano' },
		{ value: '--spacing-xxxs', name: 'xxxs' },
		{ value: '--spacing-xxs', name: 'xxs' },
		{ value: '--spacing-xs', name: 'xs' },
		{ value: '--spacing-sm', name: 'sm' },
		{ value: '--spacing-md', name: 'md' },
		{ value: '--spacing-lg', name: 'lg' },
		{ value: '--spacing-xl', name: 'xl' },
		{ value: '--spacing-xxl', name: 'xxl' },
		{ value: '--spacing-xxxl', name: 'xxxl' },
		{ value: '--spacing-giant', name: 'Giant' },
		{ value: '--spacing-titan', name: 'Titan' },
	],
	innerSpacing: [
		{ value: '--spacing-inset-atom', name: 'Atom' },
		{ value: '--spacing-inset-nano', name: 'Nano' },
		{ value: '--spacing-inset-xs', name: 'xs' },
		{ value: '--spacing-inset-sm', name: 'sm' },
		{ value: '--spacing-inset-md', name: 'md' },
		{ value: '--spacing-inset-lg', name: 'lg' },
	],
	opacity: [
		{ value: '--opacity-level-transparent', name: 'Transparent' },
		{ value: '--opacity-level-semitransparent', name: 'Semitransparent' },
		{ value: '--opacity-level-light', name: 'Light' },
		{ value: '--opacity-level-medium', name: 'Medium' },
		{ value: '--opacity-level-intense', name: 'Intense' },
		{ value: '--opacity-level-semiopaque', name: 'Semiopaque' },
		{ value: '--opacity-level-opaque', name: 'Opaque' },
	],
};

function updateVariable(newSelectedComponent, value, type, to) {
	newSelectedComponent.variables
		.find((variableTypes) => variableTypes.type == type)
		.list.find((listItem) => listItem.to == to).from = value;
}

const SelectableCssVariablesDropdown = ({ from, type, name, to }) => {
	const { props: selectedComponent, xPos, yPos, childComp } = useSelector(getSelectedComponent);
	const pageId = useSelector(selectedPage);
	const cssVar = useSelector(cssVariables);
	const dispatch = useDispatch();
	const [dropDownValue, setDropDownValue] = React.useState(from);

	function handleChange(e) {
		const value = e.target.value;
		setDropDownValue(value);
		const newSelectedComponent = JSON.parse(JSON.stringify(selectedComponent));
		updateVariable(newSelectedComponent, value, type, to);
		dispatch(
			updateComponent({
				component: newSelectedComponent,
				componentId: selectedComponent.componentId,
				pageId,
			}),
		);
		dispatch(selectComponent({ xPos, yPos, props: newSelectedComponent, childComp }));
	}

	function getValue(option) {
		if (isNaN(cssVar[option?.value]) && cssVar[option?.value]?.includes('rem')) {
			//rem to pixel
			const val = ` - ${cssVar[option.value].replace('rem', '') * 16} px`;
			return val;
		} else {
			const val = cssVar[option.value];
			return val ? ` - ${val}` : '';
		}
	}
	return (
		<Flex py={1} px={1} className="mz-hef-edit" flex={'1 1 49%'} maxW={'49%'} flexDir="column">
			<label className="mz-hef-edit-label" mb={1} fontSize={'sm'}>
				{name}
			</label>
			<select size={'sm'} defaultValue={dropDownValue} onChange={(e) => handleChange(e)}>
				{types[type].map((option, index) => (
					<option key={`scvd-option-${type}-${selectedComponent.componentId}-${index}`} value={option.value}>
						{option.name}
						{getValue(option)}
					</option>
				))}
			</select>
		</Flex>
	);
};

export default SelectableCssVariablesDropdown;
